import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

/**
 * QualiteeMed.ai Frontend Entry Point
 * Healthcare AI-powered voice-to-structured-text platform
 */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 